// extracted by mini-css-extract-plugin
module.exports = {"svg-container":"actionLoader_svg-container__NMFFG","svg-wrapper":"actionLoader_svg-wrapper__1zi06"};